import React from 'react';
import { call, put, select, take, race } from 'redux-saga/effects';
import { actions } from '../../Stream';
import { getCurrentMediaSource, getCurrentSubfolderId, getGallectionById, getCurrentFolderId, getGrusername } from '../selectors';
import { getGallectionStreamId, getGallectionType } from '../helpers';
import { unsetCurrentSubfolderId } from '../actions';
import { request } from '../../xhr';
import { isPremiumGallection, getPremiumGallectionType } from '../../utils/gallections';
import { pushGlobalConfirmationModalForMM, confirmYes, confirmNo } from '../../Modals/redux/actionCreators';
import { TrashCan, PremiumTrash } from '@wix/da-ds/pkg/Icons/Confirmations';
function* removeGallection(action) {
    const selectedFolderId = action.payload;
    const mediaSource = yield select(getCurrentMediaSource);
    const currentFolderId = yield select(getCurrentFolderId); // when we're inside a folder and removing a sub-folder
    const selectedFolder = yield select(getGallectionById, selectedFolderId);
    const username = yield select(getGrusername);
    if (!selectedFolder) {
        return;
    }
    const folderType = getPremiumGallectionType(selectedFolder) || 'regular';
    const currentSubfolderId = yield select(getCurrentSubfolderId);
    const streamId = getGallectionStreamId(mediaSource, currentFolderId);
    if (isPremiumGallection(selectedFolder)) {
        yield put(pushGlobalConfirmationModalForMM({
            titleTransKey: folderType === 'paid' ? 'mediapopup.confirmationPopup.removeFolder.title.paid' : 'mediapopup.confirmationPopup.removeFolder.title.watchers',
            textTransKey: folderType === 'paid' ? 'mediapopup.confirmationPopup.removeFolder.text.paid' : 'mediapopup.confirmationPopup.removeFolder.text.watchers',
            confirmBtnLabelTransKey: 'mediapopup.itemMenu.delete',
            cancelBtnLabelTransKey: 'popup.cancel',
            confirmBtnType: 'danger',
            icon: /*#__PURE__*/ React.createElement(PremiumTrash, null)
        }));
    } else {
        yield put(pushGlobalConfirmationModalForMM({
            titleTransKey: `mediapopup.confirmationPopup.removeFolder.${selectedFolder.type}.title`,
            textTransKey: `mediapopup.confirmationPopup.removeFolder.${selectedFolder.type}.text`,
            confirmBtnLabelTransKey: 'mediapopup.itemMenu.delete',
            cancelBtnLabelTransKey: 'popup.cancel',
            confirmBtnType: 'danger',
            icon: /*#__PURE__*/ React.createElement(TrashCan, null)
        }));
    }
    const { no  } = yield race({
        yes: take(confirmYes),
        no: take(confirmNo)
    });
    if (no) {
        return;
    }
    yield put(actions.deleteItem({
        streamId,
        item: selectedFolderId
    }));
    if (selectedFolderId === currentSubfolderId) {
        yield put(unsetCurrentSubfolderId());
    }
    var _getGallectionType;
    const data = {
        username,
        type: (_getGallectionType = getGallectionType(mediaSource)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        folderid: selectedFolderId
    };
    yield call(request, {
        method: 'post',
        url: 'gallection/folders/delete',
        data
    });
}
export default removeGallection;
